<template>
  <div class="dynamicHeader">
    <el-popover
      v-model="popoverVisible"
      placement="bottom"
      width="200"
      trigger="manual"
      popper-class="popover_class"
    >
      <div v-if="showCheckboxDom" class="checkbox_container">
        <draggable
          v-model="columnsNew"
          handle=".drag-handle"
          animation="200"
          @change="onDragChange"
          @sort="sortChange"
        >
          <el-checkbox v-model="checkAllHeader" @change="handleCheckAllChange">
            全选
          </el-checkbox>
          <div v-for="item in columnsNew" :key="item" class="draggable-item">
            <el-checkbox-group
              v-model="checkedHeaderList"
              @change="handleCheckedHeaderChange"
            >
              <el-checkbox
                :label="item"
                :disabled="item === '复选框' || item === '序号'"
              >
                <span
                  :class="[
                    item === '复选框' || item === '序号' ? '' : 'drag-handle'
                  ]"
                >
                  ☰
                </span>
                {{ item }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </draggable>
      </div>
      <div>
        <el-button type="text" @click="resetHeaderList">恢复默认</el-button>
        <el-button type="text" @click="handleConfirm">确认</el-button>
      </div>
      <div
        slot="reference"
        style="cursor: pointer"
        @click="popoverVisible = !popoverVisible"
      >
        <i class="el-icon-s-operation" />
      </div>
    </el-popover>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { getDynamicHeaderNew, updateDynamicHeaderNew } from '@/service/api-scm'

export default {
  name: 'DynamicHeader',
  components: {
    draggable
  },
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    remoteHeaderTitleEnum: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      checkAllHeader: false,
      popoverVisible: false,
      showCheckboxDom: true,
      checkedHeaderList: [],
      remoteHeaderList: [],
      localColumns: []
    }
  },

  computed: {
    columnsNew() {
      return this.localColumns.map(({ label }) => label)
    }
  },

  watch: {},

  created() {
    this.localColumns = this.columns
    console.log('New 🚗this.columns', this.columns)
  },
  async mounted() {
    // 获取远程动态表头
    if (this.remoteHeaderTitleEnum) {
      await this.getRemoteHeaderList()
      // 根据远程表头重新排序
      // this.localColumns = this.columns
      const arr = []
      this.remoteHeaderList.map((item) => {
        const items = this.localColumns.find(
          (header) => header.label === item.label
        )
        arr.push(items)
      })
      this.localColumns = arr.map(({ type = null, label, ...item }) => ({
        label: type === 'checkbox' ? '复选框' : label,
        type,
        ...item
      }))
    }
  },

  methods: {
    onDragChange(newVal) {
      const {
        moved: { oldIndex, element, newIndex }
      } = newVal
      console.log('New 🚗orderorder:event', newIndex)

      // 可在此处调用 API 保存排序结果
      this.localColumns = this.moveLabelToIndex(
        this.localColumns,
        element,
        newIndex,
        oldIndex
      )
      console.log(
        'New 🚗新排序数组',
        this.localColumns.map((item) => item.label)
      )
    },
    moveLabelToIndex(arr, element, newIndex, oldIndex) {
      // 移除目标对象
      const item = arr.splice(oldIndex - 1, 1)
      // 插入到新位置
      arr.splice(newIndex - 1, 0, item[0])
      return arr
    },

    // 全选事件
    handleCheckAllChange(val) {
      this.checkedHeaderList = val ? this.columnsNew : []
      const isAllChecked = this.checkedHeaderList.length === 0
      this.remoteHeaderList = this.localColumns.map(({ isShow, ...rest }) => ({
        ...rest,
        isShow: !isAllChecked
      }))
      // 移除['序号', '复选框']
      this.checkedHeaderList = val ? this.columnsNew : ['序号', '复选框']
      this.remoteHeaderList.forEach((item) => {
        if (item.label === '序号' || item.label === '复选框') {
          item.isShow = true
        }
      })
    },
    // 单选事件
    handleCheckedHeaderChange(checkedList) {
      this.remoteHeaderList = this.localColumns.map(({ isShow, ...rest }) => ({
        ...rest,
        isShow: checkedList.some((item) => item === rest.label)
      }))
      if (checkedList.length === this.columnsNew.length) {
        this.checkAllHeader = true
      } else {
        this.checkAllHeader = false
      }
    },
    // 确认勾选
    handleConfirm() {
      const arr = []
      this.localColumns.map((item) => {
        const items = this.remoteHeaderList.find(
          (header) => header.label === item.label
        )
        arr.push(items)
      })
      this.$emit('update-columns', arr)
      this.updateRemoteHeaderList()
      this.popoverVisible = false
    },
    // 恢复默认
    resetHeaderList() {
      this.remoteHeaderList = this.localColumns.map(({ isShow, ...rest }) => ({
        ...rest,
        isShow: true
      }))
      this.checkedHeaderList = this.columnsNew
      this.checkAllHeader = true
      this.handleConfirm()
    },
    // 获取远程动态表头
    async getRemoteHeaderList() {
      // 载荷
      const params = {
        typeEnum: this.remoteHeaderTitleEnum,
        userId: this.$store.state.user.id
      }
      // this.showCheckboxDom = false
      const { code, data } = await getDynamicHeaderNew(params)
      const resultHeader = JSON.parse(data)
      if (code === 200) {
        if (Array.isArray(resultHeader) && resultHeader.length === 0) {
          setTimeout(() => {
            this.checkedHeaderList = [...this.columnsNew]
            this.showCheckboxDom = true
            this.checkAllHeader = true
          }, 200)
        } else {
          this.checkedHeaderList = resultHeader
            .filter((item) => item.isShow)
            .map((item) => item.label)
        }

        if (this.checkedHeaderList.length === this.columnsNew.length) {
          this.checkAllHeader = true
        } else {
          this.checkAllHeader = false
        }
        this.remoteHeaderList =
          resultHeader.length > 0
            ? resultHeader
            : this.columns.map((item) => ({
                ...item,
                isShow: true
              }))
        // this.$emit('update-columns', resultHeader)
        // ------
        // 根据远程表头重新排序
        // this.localColumns = this.columns
        const arr = []
        this.remoteHeaderList.map((item) => {
          const items = this.localColumns.find(
            (header) => header.label === item.label
          )
          arr.push(items)
        })
        this.localColumns = arr
        this.handleCheckedHeaderChange(this.checkedHeaderList)

        this.$emit('update-columns', this.remoteHeaderList)
      }
    },
    // 更新/修改 动态表头
    async updateRemoteHeaderList() {
      // 载荷
      const arr = []
      this.localColumns.map((item) => {
        const items = this.remoteHeaderList.find(
          (header) => header.label === item.label
        )
        arr.push(items)
      })
      const params = {
        documentType: this.remoteHeaderTitleEnum,
        userId: this.$store.state.user.id,
        headJson: arr
      }
      await updateDynamicHeaderNew(params)
    }
  }
}
</script>
<style lang="scss" scoped>
.dynamicHeader {
  position: absolute;
  top: -35px;
  right: 0px;
}
.dynamicHeader {
  :deep(.el-popover) {
    height: 300px !important;
  }
}
.checkbox_container {
  height: 300px;
  overflow: auto;
}
.draggable-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.drag-handle {
  cursor: grab;
  margin-right: 8px;
}
.el-checkbox {
  display: block;
}
</style>
